<template>
    <div class="mx-auto container container--fluid">

        <!-- Snackbar -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">
                {{ snackbar_msg }}
            </span>
            <v-btn dark text @click="snackbar = false">
                Close
            </v-btn>
        </v-snackbar>

                <!-- Radio Buttons -->
        <v-row justify="center" dense>
            <v-radio-group
                v-model="radios"
                mandatory
                row
                class="ma-2 no-display"
            >
                <v-radio
                    label="Course Wise Remark Entry"
                    value="course"
                    color="#0f2027"
                ></v-radio>

                <v-radio
                    label="Exam Wise Remark Entry"
                    value="marksheet"
                    color="#0f2027"
                ></v-radio>
            </v-radio-group>
        </v-row>
        <!-- Show Assessment Remark when second radio is selected -->
            <div v-if="radios === 'marksheet'">
                <EnterLearnerAssessmentRemark />
            </div>
        <!-- Annual Course Marks Calculation -->
        <v-card
    class="box" v-if="ay_std_div_list != null && radios == 'course'">

            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong>Manual Subject Mark Remark</strong>
                </v-toolbar-title>
            </v-toolbar>

            <!-- Dropdowns -->
            <v-row justify="center" dense class="no-display">

                <!-- Academic Year -->
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>

                    <v-autocomplete v-model="sel_ay_data" :items="ay_std_div_list" item-text="ay" return-object
                        label="Select Academic Year" color="#0F2027" outlined dense rounded required persistent-hint
                        hint="Please select academic year" @change="getStd()" />
                </v-col>

                <!-- Semester -->
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>

                    <v-autocomplete v-model="sem" :items="semester_list" item-text="display_name" item-value="id"
                        label="Semester" color="#0F2027" outlined dense rounded required persistent-hint
                        hint="Please select semester" />
                </v-col>

                <!-- Standard -->
                <v-col cols="12" sm="2" md="2" v-if="std_div_list != null">
                    <v-icon color="error">*</v-icon>

                    <v-autocomplete v-model="sel_std_data" :items="std_div_list" item-text="std" return-object
                        label="Standard" color="#0F2027" outlined dense rounded required persistent-hint
                        hint="Please select standard" @change="getStandardSelection()" @click="putnull" />
                </v-col>

                <!-- Division -->
                <v-col cols="12" sm="2" md="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>

                    <v-autocomplete v-model="div" :items="div_list" item-text="div_name" item-value="div_off_id"
                        label="Division" color="#0F2027" outlined dense rounded required persistent-hint
                        hint="Please select division" />
                </v-col>

                <!-- Course -->
                <v-col cols="12" sm="2" md="2" v-if="crs_list.length > 0">
                    <v-icon color="error">*</v-icon>

                    <v-autocomplete v-model="crs_id" :items="crs_list" item-text="course" item-value="c_id"
                        label="Course" color="#0F2027" outlined dense rounded required persistent-hint
                        hint="Please select course" />
                </v-col>

                <!-- Fetch -->
               <v-col
                cols="12"
                sm="2"
                md="2"
                v-if="sel_ay_data && sel_std_data && div && crs_id && sem"
            >
                <v-btn
                    class="mt-6 button"
                    :loading="fetch_loader"
                    :disabled="fetch_loader"
                    @click="getreport()"
                >
                    Fetch
                </v-btn>
            </v-col>

            </v-row>
            <!-- Student Remarks Table -->
            <div class="scroll" v-if="leraner_marks.length > 0">

                <v-simple-table dense class="elevation-1 marks-table">
                    <thead>
                        <tr>
                            <th>Roll No.</th>
                            <th>Registration No.</th>
                            <th>Name</th>
                            <th>Comment</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="s in leraner_marks" :key="s.cid">
                            <!-- Roll Number -->
                            <td>{{ s.rollno }}</td>

                            <!-- Registration Number -->
                            <td>{{ s.registration_number }}</td>

                            <!-- Student Name -->
                            <td>{{ s.name }}</td>

                         
                        <!-- Comment -->
                       <!-- Comment Column with side-by-side Save button -->
<td class="comment-cell">
    <div class="d-flex align-center">
        <v-textarea
            v-model="s.comment"
            rows="2"
            outlined
            dense
            hide-details
            placeholder="Enter comment..."
            class="mr-2"
        ></v-textarea>
        
        <v-btn
            small
            class="button"
            :loading="s.saving"
            :disabled="s.saving"
            @click="saveSingleComment(s)"
        >
            Save
        </v-btn>
    </div>
</td>
                        </tr>
                    </tbody>
                </v-simple-table>

            </div>

            <!-- Save All -->
         <!-- Save Comments -->
            <div class="text-center mt-4 pb-4">
                <v-btn
                    v-if="leraner_marks.length > 0"
                    class="button"
                    :loading="fetch_loader"
                    :disabled="fetch_loader"
                    @click="saveLearnerComments"
                >
                    Save/Update Comments
                </v-btn>
            </div>

        </v-card>
    </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css";
import EnterLearnerAssessmentRemark from "./EnterLearnerAssessmentRemark.vue";

export default {
    name: "EnterLearnerSubjectRemark",
    components: {
        EnterLearnerAssessmentRemark
    },

    data() {
        return {
            snackbar: false,
             radios: "course",
            snackbar_msg: "",
            color: "",
            fetch_loader: false,
            role: null,
            // Academic Year
            ay_std_div_list: null,
            sel_ay_data: null,
            // Standard
            std_div_list: null,
            sel_std_data: null,
            // Division
            div_list: null,
            div: null,
            // Semester
            semester_list: [],
            sem: null,
            // Course
            crs_list: [],
            crs_id: null,
            leraner_marks: [],
        };
    },

    methods: {
        
        // Clear course when changing Standard
        putnull() {
            this.crs_list = [];
            this.crs_id = null;
        },

        // Run both operations after Standard selection
        getStandardSelection() {
            this.getDiv();
            this.getStandardCourse();
        },

       
async saveLearnerComments() {
    if (
        !this.sel_ay_data ||
        !this.sel_std_data ||
        !this.div ||
        !this.crs_id ||
        !this.sem
    ) {
        this.showSnackbar("#b71c1c", "Please select all required fields");
        return;
    }

    this.fetch_loader = true;

    try {
        const res = await axios.post(
            "/DataMigration/saveLearnerCourseMarksComment",
            {
                ay: this.sel_ay_data.ay_id,
                standard: this.sel_std_data.std_id,
                div: this.div,
                crs_id: this.crs_id,
                sem: this.sem,
                marks_data: this.leraner_marks
            }
        );

        if (res.data.flag === "YES") {
            this.showSnackbar(
                "#4caf50",
                res.data.message || "Comments updated successfully"
            );

            // Keep the current rows and comments visible.
            // Do not call getreport() here.
        } else {
            this.showSnackbar(
                "#b71c1c",
                res.data.message || "Some comments could not be updated"
            );

            console.log(
                "Save status:",
                res.data.statuslist || res.data.error_trace
            );
        }
    } catch (err) {
        console.error("Error saving comments:", err);
        this.showSnackbar("#b71c1c", "Something went wrong...");
    } finally {
        this.fetch_loader = false;
    }
},
       async getreport() {
    if (
        !this.sel_ay_data ||
        !this.sel_std_data ||
        !this.div ||
        !this.crs_id ||
        !this.sem
    ) {
        this.showSnackbar(
            "#b71c1c",
            "Please select all required fields"
        );
        return;
    }

    this.hide_show = false;

    const data = {
        ay: this.sel_ay_data.ay_id,
        standard: this.sel_std_data.std_id,
        crs_id: this.crs_id,
        sem: this.sem,
        div: this.div
    };

    this.fetch_loader = true;

    try {
        const res = await axios.post(
            "/WWSExamination/annualCourseMarksCalculation",
            data
        );

        if (res.data.flag === "YES") {
            this.leraner_marks = res.data.leraner_marks || [];
            this.leraner_marks.forEach((s) => {
            this.$set(
            s,
            "comment",
            s.comment != null ? s.comment : ""
            );
            this.$set(s, "saving", false);
            });
            this.remarks_list = res.data.remarks_list || [];
            this.ass_details_for_marksheet =
                res.data.ass_details_for_marksheet || [];
            this.grade_details = res.data.grade_details || [];
        } else if (res.data.flag === "NO") {
            this.showSnackbar("#b71c1c", res.data.fmsg);
        } else {
            sessionStorage.setItem(
                "error-trace",
                res.data.error_trace
            );
        }
    } catch (err) {
        console.log("Error fetching course marks:", err);
        this.onerror(err);
    } finally {
        this.fetch_loader = false;
    }
},
  
async saveSingleComment(studentData) {
    if (
        !this.sel_ay_data ||
        !this.sel_std_data ||
        !this.div ||
        !this.crs_id ||
        !this.sem
    ) {
        this.showSnackbar("#b71c1c", "Please select all required fields");
        return;
    }

    this.$set(studentData, "saving", true);

    try {
        const res = await axios.post(
            "/DataMigration/saveLearnerCourseMarksComment",
            {
                ay: this.sel_ay_data.ay_id,
                standard: this.sel_std_data.std_id,
                div: this.div,
                crs_id: this.crs_id,
                sem: this.sem,
                marks_data: [studentData]
            }
        );

        if (res.data.flag === "YES") {
            this.showSnackbar(
                "#4caf50",
                `Comment saved for ${studentData.name || "student"}`
            );
        } else {
            this.showSnackbar(
                "#b71c1c",
                res.data.message || "Failed to save comment"
            );
            console.log("Save status:", res.data.statuslist || res.data.error_trace);
        }
    } catch (err) {
        console.error("Error saving comment:", err);
        this.showSnackbar("#b71c1c", "Something went wrong...");
    } finally {
        this.$set(studentData, "saving", false);
    }
},

        getStandardCourse() {
            if (!this.sel_ay_data || !this.sel_std_data) {
                return;
            }

            this.role = localStorage.getItem("para_role");

            const data = {
                ay: this.sel_ay_data.ay_id,
                standard: this.sel_std_data.std_id,
                role: this.role
            };

            axios
                .post("/Examination/getStandardCourse_WWS", data)
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.crs_list = res.data.courses_list || [];
                    } else if (res.data.flag === "NO") {
                        this.crs_list = [];
                        this.showSnackbar(
                            "#b71c1c",
                            "No courses offered for this standard..."
                        );
                    }
                })
                .catch((error) => {
                    console.log("Error loading courses:", error);
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                });
        },

        // Load Standards for selected Academic Year
        getStd() {
            this.std_div_list = null;
            this.sel_std_data = null;

            this.div_list = null;
            this.div = null;

            this.crs_list = [];
            this.crs_id = null;

            this.sem = null;
            this.leraner_marks = [];

            if (this.sel_ay_data) {
                this.std_div_list = this.sel_ay_data.std_list || [];
            }
        },

        // Load Divisions for selected Standard
        getDiv() {
            this.div_list = null;
            this.div = null;

            this.crs_list = [];
            this.crs_id = null;

            this.leraner_marks = [];

            if (!this.sel_std_data) {
                return;
            }

            this.div_list = this.sel_std_data.div_list || [];

            if (this.div_list.length === 0) {
                this.showSnackbar("#b71c1c", "No division found!");
                this.div_list = null;
            }
        },

        // Snackbar message
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },

        // Error handling
        onerror(err) {
            console.error(err);
            this.showSnackbar("#b71c1c", "Something went wrong...");
        },

        // Load Academic Years and Semesters
        onload() {
            this.role = localStorage.getItem("para_role");

            const data = {
                role: this.role
            };

            axios
                .post("/commonAPI/get_ay_std_div_wws", data)
                .then((res) => {
                    this.ay_std_div_list =
                        res.data.data || [];

                    this.semester_list =
                        res.data.sem_list || [];
                })
                .catch((error) => {
                    console.log("Error loading academic years:", error);
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                });
        }
    },

    mounted() {
        this.onload();
    }
};
</script>

<style scoped>
.box {
    margin: 10px;
    padding: 10px;
    border-radius: 5px;
}

.toolbar {
    background-color: #ffffff !important;
    color: #0f2027 !important;
}

@media print {
    .no-display {
        display: none !important;
    }
}

.scroll {
    width: 100%;
    overflow-x: auto;
}

.marks-table {
    width: 100%;
    white-space: nowrap;
    text-align: center;
    font-size: 14px;
}

.marks-table ::v-deep thead th {
    background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important;
    color: #ffffff !important;
    font-weight: bold !important;
    text-align: center !important;
    padding: 12px !important;
}

.marks-table ::v-deep tbody td {
    border: 1px solid #cccccc;
    text-align: center;
    vertical-align: middle;
    padding: 8px !important;
}

.marks-table ::v-deep tbody tr:hover {
    background-color: #f2f6f8 !important;
}

.comment-cell {
    min-width: 280px;
    width: 40%;
    padding: 8px !important;
}

.comment-cell ::v-deep textarea {
    font-size: 14px;
    line-height: 1.4;
}

.comment-cell {
    min-width: 360px;
    width: 45%;
    padding: 8px !important;
}
</style>